import { lazy, Suspense } from "react";

import { MapRouteLoader } from "components/map/RouteLoader";

const MapLazy = lazy(() => import("components/map/Map"));

export const SystemOverviewHybridMap = () => {
  return (
    <Suspense fallback={<MapRouteLoader />}>
      <MapLazy basemapId="hybrid" />
    </Suspense>
  );
};

export default SystemOverviewHybridMap;
